import {Component, EventEmitter, Input, Output} from "@angular/core";

import {
  faCaretDown,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faFloppyDisk
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";

@Component({
    selector: 'full-length-pagination',
    imports: [FontAwesomeModule, FormsModule],
    templateUrl: './full-length-pagination.component.html',
    styleUrls: ['./full-length-pagination.component.css']
})
export class FullLengthPaginationComponent {
  @Input('currentPagination') currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  @Input('perPageText') perPageText: string = 'Items'
  @Output() currentPaginationChange: EventEmitter<Pagination> = new EventEmitter<Pagination>();
  @Output() perPageFunction = new EventEmitter<Function>()
  @Output() decrementPageFunction = new EventEmitter<Function>()
  @Output() incrementPageFunction = new EventEmitter<Function>()
  @Output() paginationService = new EventEmitter<Function>();
  showPerPageDropdown = false

  changePaginationLimit(limit: number) {
    // TODO call the pagination service
    this.currentPagination.limit = limit;
    this.showPerPageDropdown = false
    this.currentPaginationChange.emit(this.currentPagination);
    this.paginationService.emit()
  }

  changePage(page: number) {
    // TODO call the pagination service
    // TODO I don't know if size in pagination is correct here
    if(page <= Math.ceil(this.currentPagination.totalcount / this.currentPagination.limit) && page >= 0)
      this.currentPagination.page = page

    this.currentPaginationChange.emit(this.currentPagination);
    this.paginationService.emit()
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faCaretDown = faCaretDown;
  protected readonly faChevronDown = faChevronDown;
  protected readonly Math = Math;
}
